<script>
import { mapGetters } from 'vuex';

// Prefer application images to known sidecars; every image remains accessible in details.
const IGNORE_IMAGES = ['istio/proxy', 'gcr.io/istio-release/proxy', 'mirrored-istio-proxy'];

export default {
  props: {
    value: { type: [Array, String], default: () => [] },
    row:   { type: Object, default: () => ({}) },
  },
  data() {
    return { expanded: false };
  },
  computed: {
    ...mapGetters({ t: 'i18n/t' }),
    images() {
      const value = this.row?.imageNames ?? this.value;

      return (Array.isArray(value) ? value : typeof value === 'string' ? [value] : []).filter((image) => typeof image === 'string' && image.length > 0);
    },
    mainImage() {
      return this.images.find((image) => !IGNORE_IMAGES.some((prefix) => image.includes(prefix))) || this.images[0] || '';
    },
    additionalImages() {
      const mainIndex = this.images.indexOf(this.mainImage);

      return this.images.filter((_image, index) => index !== mainIndex);
    },
  },
  watch: {
    row() {
      this.expanded = false;
    },
    value() {
      this.expanded = false;
    },
  },
};
</script>

<template>
  <div class="formatter-pod-images">
    <span
      v-if="mainImage"
      class="image-reference"
      :title="mainImage"
    >{{ mainImage }}</span>
    <span
      v-else
      class="text-muted"
    >—</span>
    <button
      v-if="additionalImages.length"
      type="button"
      class="btn role-link image-toggle"
      :aria-expanded="expanded"
      @click.stop="expanded = !expanded"
    >
      {{ expanded ? t('generic.showLess') : t('generic.plusMore', {n: additionalImages.length}) }}
    </button>
    <div
      v-if="expanded"
      class="additional-images"
    >
      <span
        v-for="(image, index) in additionalImages"
        :key="index"
        class="additional-image"
        :title="image"
      >{{ image }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.formatter-pod-images { min-width: 0; font-size: 12px; line-height: 1.5; }
.image-reference { display: block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--body-text); }
.image-toggle { padding: 0; min-height: 24px; font-size: 12px; }
.additional-images { display: flex; flex-direction: column; gap: 5px; margin-top: 5px; }
.additional-image { padding: 5px 7px; border: 1px solid var(--border); border-radius: 5px; background: var(--simple-box-bg, var(--body-bg)); color: var(--muted); overflow-wrap: anywhere; word-break: normal; }
</style>
